// import { UnitSelectionWidget, ShopSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  // shop_id: {
  //   'ui:widget': ShopSelectionWidget,
  // },
  // unit_id: {
  //   'ui:widget': UnitSelectionWidget,
  // },
});

export default uiSchema;
